module.exports = __webpack_public_path__ + "static/media/19.08.0c5d0494.webp";